var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"msp-grafico-andature-semplice"},_vm._l((_vm.items),function(item,i){return _c('div',{key:i,staticClass:"andatura",style:(_vm.getStyle(item))},[_c('div',{staticClass:"andatura-bar"})])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }